import api from './api'
import type { Site, Floor } from '../types'

export const siteApi = {
  getSites: (clientId?: string) =>
    api.get<Site[]>('/sites', { params: clientId ? { client_id: clientId } : undefined }).then((r) => r.data),
  getSite: (id: string) => api.get<Site>(`/sites/${id}`).then((r) => r.data),
  createSite: (data: { client_id: string; name: string; slug?: string; is_ifc_source?: boolean; ifc_rotation?: number; metadata?: Record<string, unknown> }) =>
    api.post<Site>('/sites', data).then((r) => r.data),
  updateSite: (id: string, data: { name?: string; client_id?: string; ifc_rotation?: number | null; metadata?: Record<string, unknown> | null; is_active?: boolean | null }) =>
    api.patch<Site>(`/sites/${id}`, data).then((r) => r.data),
  deleteSite: (id: string) => api.delete(`/sites/${id}`),
  getFloors: (siteId: string) => api.get<Floor[]>(`/sites/${siteId}/floors`).then((r) => r.data),
  getFloorplanUrl: (siteId: string, floor: number) =>
    api.get<{ url: string }>(`/sites/${siteId}/floorplans/${floor}`).then((r) => r.data.url),
  uploadFloorplan: (siteId: string, floor: number, file: File) => {
    const form = new FormData()
    form.append('file', file)
    form.append('floor', String(floor))
    return api.post(`/sites/${siteId}/floorplans`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  getIFCGeometryUrls: (siteId: string) =>
    api.get<Record<string, string>>(`/sites/${siteId}/ifc-walls/geometry-url`).then((r) => r.data),
  importIFC: (name: string, fileContent: string) =>
    api.post<Site>('/sites/import-ifc', { name, ifc_json: fileContent }).then((r) => r.data),
}
